import './YahooSignInButton.scss'

import { YahooFilled } from '@ant-design/icons'
import { useState } from 'react'

import Button from '../Button/Button'

export const YahooSignInButton = () => {
  const [loading, setLoading] = useState(false)
  const urlParams = new URLSearchParams(window.location.search)

  const handleYahooSignIn = () => {
    setLoading(true)
    window.location.href = `${process.env.REACT_APP_API_URL}/api/auth/member/yahoo/login`
  }

  return (
    <div className="yahoo-sign-in-wrapper">
      <Button
        className="yahoo-sign-in-wrapper-button Secondary"
        onClick={handleYahooSignIn}
        loading={loading}
        disabled={loading}
      >
        Sign in with <YahooFilled size={30} />
      </Button>
    </div>
  )
}
